import { Button } from '@/components/atoms'
import { SaveReportContent } from '@/components/molecules/SaveReportContent/SaveReportContent'
import { GetReportResponse } from '@/hooks'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

type SaveAsNewReportButtonProps = {
    label: string
    report: GetReportResponse
    onSuccess?: () => void
    onPendingSave?: (isPending: boolean) => void
}

export const SaveAsNewReportButton: React.FC<SaveAsNewReportButtonProps> = ({
    label,
    report,
    onSuccess,
    onPendingSave,
}) => {
    const { t } = useTranslation('translations')

    const setModalState = useGlobalModalStore((state) => state.setModalState)

    const handleClickSaveReport = useCallback(() => {
        const labels = {
            saveButton: t(
                'reporting.save_report.save_as_new_report_modal.save_button'
            ),
            loadingSaveButton: t(
                'reporting.save_report.save_as_new_report_modal.loading_save_button'
            ),
        }

        setModalState({
            isOpen: true,
            title: t('reporting.save_report.save_as_new_report_modal.title'),
            description: t(
                'reporting.save_report.save_as_new_report_modal.description'
            ),
            content: () => (
                <SaveReportContent
                    reportType={report.type}
                    labels={labels}
                    report={report}
                    handleOnSuccess={onSuccess}
                    onPendingSave={onPendingSave}
                />
            ),
            onClose: () => {
                setModalState({ isOpen: false })
            },
        })
    }, [onPendingSave, onSuccess, report, setModalState, t])

    return (
        <Button
            name="saveReport"
            size="large"
            variant="outlinePrimary"
            onClick={() => {
                handleClickSaveReport()
            }}
            className="whitespace-nowrap font-medium"
        >
            {label}
        </Button>
    )
}
